import { Component, Host, h, Element, Prop } from '@stencil/core';

/**
 * Main component for displaying a chart tooltip.
 * This component should wrap `aha-chart-tooltip-record` and `aha-chart-tooltip-value` components.
 * @slot default - `aha-chart-tooltip-record` and `aha-chart-tooltip-value` components.
 * @prop {string} header - Optional header text for the tooltip.
 * @prop {boolean} multiple - If true, the tooltip will apply styles for multiple records
 */
@Component({
  tag: 'aha-chart-tooltip',
  styleUrl: 'aha-chart-tooltip.css',
  shadow: true,
})
export class AhaChartTooltip {
  @Element() host!: HTMLAhaChartTooltipElement;
  @Prop() header?: string;
  @Prop() multiple?: boolean = false;

  render() {
    return (
      <Host class={this.multiple ? 'multiple' : 'single'}>
        {this.header && <div id="header">{this.header}</div>}
        <slot></slot>
      </Host>
    );
  }
}
